module.exports = __webpack_public_path__ + "static/media/ts2.82e6de13.png";